export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 100;

export const MAX_EMAIL_LENGTH = 100;

export const OTP_LENGTH = 5;
